import { academyApi, type B2gContractSignatureBody } from '@mathflat/domain/Academy'

import { mpEventInfo } from '@/constant'
import { B2gContract } from '@/dto/B2g/B2gContract'

class ContractController {
  // crm에서 전송한 계약서 정보
  async fetchContractInfo() {
    const contract = await academyApi.getB2gContract({
      mp_event_name: mpEventInfo.b2g계약서_정보조회,
    })
    return new B2gContract(contract ?? undefined)
  }
  // 계약서 제출
  async submitContract(data: B2gContractSignatureBody) {
    await academyApi.signB2gContract(data, { mp_event_name: mpEventInfo.b2g계약서_제출 })
  }
  // 계약서 다운로드
  async downloadContractPdf() {
    return academyApi.getB2gContractPdf({ mp_event_name: mpEventInfo.b2g계약서_다운로드 })
  }
}
export const contractController = new ContractController()
